module.exports = require('./CommentsDocumentView');
